module.exports = require('./CommentsDocumentView');
